"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// TODO : keyboard controls. See tlSelect.js

ngModule.directive("tlIconInput", function ($document, fontAwesomeIconList) {
  return {
    restrict: "E",
    scope: true,
    require: ["tlIconInput", "ngModel"],
    controllerAs: "inputCtrl",
    replace: true,
    template: require("./tl-icon-input.html"),
    link: function link($scope, $el, $attrs, ctrls) {
      var ctrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      ctrl.setModelCtrl(ngModelCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        dropdownEl = $element.find(".tl-icon-input-dropdown"),
        modelCtrl = null;
      ctrl.state = {
        opened: false
      };
      ctrl.setModelCtrl = function (_ngModelCtrl) {
        modelCtrl = _ngModelCtrl;
        $scope.$watch(function () {
          return modelCtrl.$modelValue;
        }, function (modelValue) {
          $scope.iconId = modelValue;
        });
      };
      ctrl.toggleIconSelectorMenu = function () {
        if (ctrl.state.opened) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      ctrl.selectIcon = function (iconId) {
        modelCtrl.$setViewValue(iconId);
        modelCtrl.$commitViewValue();
        ctrl.closeDropdown();
      };
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        dropdownEl.show().width(dropdownEl.width()) // avoid .position to set width auto.
        .appendTo(document.body).position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        _.defer(function () {
          bindClickHandler();
        });
        ctrl.state.opened = true;
      };
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: "",
          width: ""
        });
        unbindClickHandler();
        ctrl.state.opened = false;
      };
      ctrl.getIconList = function () {
        return fontAwesomeIconList;
      };
      var onDocumentClick = function onDocumentClick(e) {
        var parents = $(e.target).parents();
        if (parents.index($element) > -1) {
          return;
        }
        $scope.$apply(function () {
          ctrl.closeDropdown();
        });
      };
      var bindClickHandler = function bindClickHandler() {
        $document.bind("click", onDocumentClick);
      };
      var unbindClickHandler = function unbindClickHandler() {
        $document.unbind("click", onDocumentClick);
      };
      $scope.$on("$destroy", function () {
        unbindClickHandler();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-icon-input.js
// module id = 2973
// module chunks = 13